export default __webpack_public_path__ + "static/media/converse-W.a0c8119e.png";